import { render, staticRenderFns } from "./AutobepreisungOptions.vue?vue&type=template&id=512d20f6&scoped=true&"
import script from "./AutobepreisungOptions.vue?vue&type=script&lang=js&"
export * from "./AutobepreisungOptions.vue?vue&type=script&lang=js&"
import style0 from "./AutobepreisungOptions.vue?vue&type=style&index=0&id=512d20f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512d20f6",
  null
  
)

export default component.exports